export type GetBookingSendEmailAndSmsParamsOptions = {
  send_sms?: boolean
  send_email?: boolean
}

export function getBookingSendEmailAndSmsParams(
  options?: GetBookingSendEmailAndSmsParamsOptions
) {
  if (!options) {
    return undefined
  }

  return {
    ...options,
    send_sms:
      Boolean(
        Number(process.env.NEXT_PUBLIC_SAAS_ENABLE_FEATURE_BOOKING_SMS)
      ) === true
        ? options?.send_sms
        : false,
    send_email:
      Boolean(
        Number(process.env.NEXT_PUBLIC_SAAS_ENABLE_FEATURE_BOOKING_EMAILS)
      ) === true
        ? options?.send_email
        : false,
  }
}
